module.exports = __webpack_public_path__ + "img/dsci0153.fe9f6cba.jpg";